import { render, staticRenderFns } from "./soidown-page.vue?vue&type=template&id=aefde1ca"
import script from "./soidown-page.vue?vue&type=script&lang=js"
export * from "./soidown-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aefde1ca')) {
      api.createRecord('aefde1ca', component.options)
    } else {
      api.reload('aefde1ca', component.options)
    }
    module.hot.accept("./soidown-page.vue?vue&type=template&id=aefde1ca", function () {
      api.rerender('aefde1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/soidown-page.vue"
export default component.exports